import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET targeted/v1/definitions/by-content
 */
export function fetchSmartCriterion(pageId, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`targeted/v1/definitions/by-content/${pageId}`);
}